/* eslint-disable standard/object-curly-even-spacing */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './http'
import 'font-awesome/css/font-awesome.css'
import router from './router'

import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@/assets/css/layout.css'
import scroll from './components/scroll'
import store from './store'
import VueWechatTitle from 'vue-wechat-title'
import { Button, NavBar, Cell, CellGroup, RadioGroup, Radio, Field, Tab, Row, Col, Tabs, Popup, Loading, Card, Tag, List, Dialog, Toast } from 'vant'
Vue.use(VueWechatTitle)

Vue.use(scroll)
Vue.use(Button)
  .use(NavBar)
  .use(Cell)
  .use(CellGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Field)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
  .use(Card)
  .use(Tag)
  .use(List)
  .use(Row)
  .use(Col)
  .use(Dialog)
  .use(Loading)
  .use(Toast)
Vue.component(Field.name, {
  extends: Field,
  props: {
    formatter: {
      type: Function,
      default: function (value) {
        return value.replace(/\s+/g, "");
      },
    },
  },
});
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js